export const CONFIG_DAY_SETTING_FIELD = {
  enableAutoSentNotiBefore30Days: "Trước 30 ngày",
  enableAutoSentNotiBefore15Days: "Trước 15 ngày",
  enableAutoSentNotiBefore7Days: "Trước 7 ngày",
  enableAutoSentNotiBefore3Days: "Trước 3 ngày",
  enableAutoSentNotiBefore1Days: "Trước 1 ngày",
  enableAutoSentNotiBeforeOtherDays: "Khác",
};

export const CONFIG_SETTING_NOTIFICATION_FIELD = {
  enableNotiByAPNS: "Thông báo qua APNS",
  enableNotiBySmsCSKH: "Thông báo qua SMS CSKH",
  enableNotiByZaloCSKH: "Thông báo qua Zalo CSKH",
  enableNotiBySMSRetry: "Thông báo qua SMS Retry",
  enableNotiByAutoCall: "Thông báo qua Auto Call",
};

export const CONFIG_SETTING_TEMPLATE_KEY = {
  SMS_CSKH_REMINDER_VEHICLE_INSPECTION_1: 1001, // Nhắc đăng kiểm mẫu 1
  SMS_CSKH_REMINDER_VEHICLE_INSPECTION_2: 1002, // Nhắc đăng kiểm mẫu 2
  SMS_AUTO_NOTIFY_VIOLATION_1: 1003, // Tự động thông báo phạt ngội 1

  SMS_PROMOTION_INSURANCE_1: 2003, // Khuyến mãi bảo hiểm mẫu 1
  SMS_PROMOTION_MAINTENANCE_1: 2004, // Khuyến mãi bảo dưỡng xe mẫu 1
  SMS_PROMOTION_REMINDER_MAINTENANCE_1: 2005, // Nhắc hẹn bảo dưỡng xe mẫu
  SMS_PROMOTION_MAINTENANCE_2: 2006, // Khuyến mãi bảo dưỡng xe mẫu 2
  SMS_PROMOTION_ADVERTISING_MAINTENANCE_1: 2007, // Quảng cáo bảo dưỡng xe mẫu 1
  SMS_PROMOTION_ADVERTISING_HELPER_1: 2008, // Quảng cáo cứu hộ mẫu 1
  SMS_PROMOTION_HELPER_1: 2009, // Khuyến mãi cứu hộ xe mẫu 1

  ZALO_CSKH_REMINDER_VEHICLE_INSPECTION_1: 3010, // Nhắc đăng kiểm qua Zalo  mẫu 1
  ZALO_CSKH_REMINDER_VEHICLE_INSPECTION_2: 3011, // Nhắc đăng kiểm qua Zalo mẫu 2
  ZALO_CSKH_REMINDER_VEHICLE_INSPECTION_3: 3012, // Nhắc đăng kiểm qua Zalo mẫu 3
  ZALO_CSKH_REMINDER_VEHICLE_INSPECTION_4: 3013, // Nhắc đăng kiểm qua Zalo mẫu 4
  ZALO_CSKH_REMINDER_VEHICLE_INSPECTION_5: 3014, // Nhắc lịch đăng kiểm kèm giảm giá
  ZALO_CSKH_REMINDER_VEHICLE_INSPECTION_6: 3015, // Nhắc đăng kiểm qua Zalo mẫu 6
  ZALO_CSKH_NOTIFY_SCHEDULE_COMFIRMED: 3016, // Thông báo cho khách biết về thông tin lịch
  ZALO_CSKH_NOTIFY_MANAGEMENT_STATION: 3017, // Quản lý trung tâm trên TTDK
  ZALO_CSKH_NOTIFY_CONSULTANT_SCHEDULE: 3018, // Thông báo Xác nhận thông tin lịch hẹn tư vấn
  ZALO_CSKH_CONFIRM_CONSULTANT_SCHEDULE: 3019, // Xác nhận lịch tư vấn
  ZALO_CSKH_NOTIFY_CRIMINAL_RESULT: 3020, // Nhắc kết quả tra cứu phạt nguội (có phạt nguội)
  ZALO_CSKH_NOTIFY_MAINTENANCE_REMINDER_1_DAY: 3021, // Nhắc đi bảo dưỡng trước trước ngày đăng kiểm 1 ngày
  ZALO_CSKH_NOTIFY_MAINTENANCE_REMINDER_3_DAY: 3022, // Nhắc đi bảo dưỡng trước trước ngày đăng kiểm 2 ngày
  ZALO_CSKH_NOTIFY_MAINTENANCE_REMINDER: 3023, // Nhắc đi bảo dưỡng trước n ngày đăng kiểm
  ZALO_CSKH_PRE_INSPECTION_REMINDER: 3024, // Nhắc trước lúc KH chuẩn bị mang xe đi đăng kiểm
  ZALO_CSKH_NOTIFY_CHECK: 3035, // Nhắc trước lúc KH chuẩn bị mang xe đi đăng kiểm

  ZALO_PROMOTION_INSURANCE_1: 4012, // Khuyến mãi bảo hiểm qua Zalo mẫu 1
  ZALO_PROMOTION_MAINTENANCE_1: 4013, // Khuyến mãi bảo dưỡng xe qua Zalo mẫu 1
  ZALO_PROMOTION_REMINDER_MAINTENANCE_1: 4014, // Nhắc hẹn bảo dưỡng xe qua Zalo mẫu 1
  ZALO_PROMOTION_MAINTENANCE_2: 4015, // Khuyến mãi bảo dưỡng xe qua Zalo mẫu 2
  ZALO_PROMOTION_ADVERTISING_MAINTENANCE_1: 4016, // Quảng cáo bảo dưỡng xe qua Zalo mẫu 1
  ZALO_PROMOTION_ADVERTISING_HELPER_1: 4017, // Quảng cáo cứu hộ qua Zalo mẫu 1
  ZALO_PROMOTION_HELPER_1: 4018, // Khuyến mãi cứu hộ xe qua Zalo mẫu 1
  ZALO_PROMOTION_VOUCHER_INSURANCE: 4019, // Thông báo khuyến mãi BH TNDS.

  REPORT_DAILY_1: 5019, // Báo cáo tình hình hoạt động trong ngày tại trạm 1
  REPORT_WEEKLY: 5020, // Báo cáo tình hình hoạt động trong tuần tại trạm
  REPORT_DAILY_2: 5021, // Báo cáo tình hình hoạt động trong ngày tại trạm 2

  STATION_SMS_CSKH_REMINDER_VEHICLE_INSPECTION_3: 6022, // Nhắc đăng kiểm mẫu 3
  STATION_SMS_CSKH_REMINDER_VEHICLE_INSPECTION_4: 6023, // Nhắc đăng kiểm mẫu 4
  STATION_SMS_CSKH_REMINDER_INSURANCE_TNDS: 6024, // Mẫu nhắc gia hạn bảo hiểm TNDS
  STATION_SMS_CSKH_REMINDER_INSURANCE_BHTV: 6025, // Mẫu nhắc gia hạn bảo hiểm thân vỏ xe
  STATION_SMS_CSKH_REMINDER_SERVICE_GPS: 6026, // Mẫu nhắc gia hạn dịch vụ GPS
};

export const CONFIG_SETTING_TEMPLATE_KEY_LIST = {
  messageTemplateAPNS:1,
  messageTemplateSmsCSKH:2,
  messageTemplateZaloCSKH:3,
  messageTemplateSMSRetry:4,
  messageTemplateAutoCall:5,
}

export const CONFIG_SETTING_TEMPLATE_VALUE = {
  SMS_CSKH_REMINDER_VEHICLE_INSPECTION_1: "Nhắc đăng kiểm mẫu 1",
  SMS_CSKH_REMINDER_VEHICLE_INSPECTION_2: "Nhắc đăng kiểm mẫu 2",
  SMS_AUTO_NOTIFY_VIOLATION_1: "Tự động thông báo phạt ngội 1",
  SMS_PROMOTION_INSURANCE_1: "Khuyến mãi bảo hiểm mẫu 1",
  SMS_PROMOTION_MAINTENANCE_1: "Khuyến mãi bảo dưỡng xe mẫu 1",
  SMS_PROMOTION_REMINDER_MAINTENANCE_1: "Nhắc hẹn bảo dưỡng xe mẫu",
  SMS_PROMOTION_MAINTENANCE_2: "Khuyến mãi bảo dưỡng xe mẫu 2",
  SMS_PROMOTION_ADVERTISING_MAINTENANCE_1: "Quảng cáo bảo dưỡng xe mẫu 1",
  SMS_PROMOTION_ADVERTISING_HELPER_1: "Quảng cáo cứu hộ mẫu 1",
  SMS_PROMOTION_HELPER_1: "Khuyến mãi cứu hộ xe mẫu 1",
  ZALO_CSKH_NOTIFY_CHECK:"Thông báo nhắc hạn đăng kiểm",
  ZALO_CSKH_REMINDER_VEHICLE_INSPECTION_1: "Nhắc đăng kiểm qua Zalo  mẫu 1",
  ZALO_CSKH_REMINDER_VEHICLE_INSPECTION_2: "Nhắc đăng kiểm qua Zalo mẫu 2",
  ZALO_CSKH_REMINDER_VEHICLE_INSPECTION_3: "Nhắc đăng kiểm qua Zalo mẫu 3",
  ZALO_CSKH_REMINDER_VEHICLE_INSPECTION_4: "Nhắc đăng kiểm qua Zalo mẫu 4",
  ZALO_CSKH_REMINDER_VEHICLE_INSPECTION_5: "Nhắc đăng kiểm kèm giảm giá",
  ZALO_CSKH_REMINDER_VEHICLE_INSPECTION_6: "Nhắc lịch đăng kiểm khi đến hạn",
  ZALO_CSKH_NOTIFY_SCHEDULE_COMFIRMED:
    "Thông báo cho khách biết về thông tin lịch",
  ZALO_CSKH_NOTIFY_MANAGEMENT_STATION: "Quản lý trung tâm trên TTDK",
  ZALO_CSKH_NOTIFY_CONSULTANT_SCHEDULE:
    "Thông báo Xác nhận thông tin lịch hẹn tư vấn",
  ZALO_CSKH_CONFIRM_CONSULTANT_SCHEDULE: "Xác nhận lịch tư vấn",
  ZALO_CSKH_NOTIFY_CRIMINAL_RESULT:
    "Nhắc kết quả tra cứu phạt nguội (có phạt nguội)",
  ZALO_CSKH_NOTIFY_MAINTENANCE_REMINDER_1_DAY:
    "Nhắc đi bảo dưỡng trước trước ngày đăng kiểm 1 ngày",
  ZALO_CSKH_NOTIFY_MAINTENANCE_REMINDER_3_DAY:
    "Nhắc đi bảo dưỡng trước trước ngày đăng kiểm 2 ngày",
  ZALO_CSKH_NOTIFY_MAINTENANCE_REMINDER:
    "Nhắc đi bảo dưỡng trước n ngày đăng kiểm",
  ZALO_CSKH_PRE_INSPECTION_REMINDER:
    "Nhắc trước lúc KH chuẩn bị mang xe đi đăng kiểm",
  ZALO_PROMOTION_INSURANCE_1: "Khuyến mãi bảo hiểm qua Zalo mẫu 1",
  ZALO_PROMOTION_MAINTENANCE_1: "Khuyến mãi bảo dưỡng xe qua Zalo mẫu 1",
  ZALO_PROMOTION_REMINDER_MAINTENANCE_1: "Nhắc hẹn bảo dưỡng xe qua Zalo mẫu 1",
  ZALO_PROMOTION_MAINTENANCE_2: "Khuyến mãi bảo dưỡng xe qua Zalo mẫu 2",
  ZALO_PROMOTION_ADVERTISING_MAINTENANCE_1:
    "Quảng cáo bảo dưỡng xe qua Zalo mẫu 1",
  ZALO_PROMOTION_ADVERTISING_HELPER_1: "Quảng cáo cứu hộ qua Zalo mẫu 1",
  ZALO_PROMOTION_HELPER_1: "Khuyến mãi cứu hộ xe qua Zalo mẫu 1",
  ZALO_PROMOTION_VOUCHER_INSURANCE: "Thông báo khuyến mãi BH TNDS.",
  REPORT_DAILY_1: "Báo cáo tình hình hoạt động trong ngày tại trạm 1",
  REPORT_WEEKLY: "Báo cáo tình hình hoạt động trong tuần tại trạm",
  REPORT_DAILY_2: "Báo cáo tình hình hoạt động trong ngày tại trạm 2",
  STATION_SMS_CSKH_REMINDER_VEHICLE_INSPECTION_3: "Nhắc đăng kiểm mẫu 3",
  STATION_SMS_CSKH_REMINDER_VEHICLE_INSPECTION_4: "Nhắc đăng kiểm mẫu 4",
  STATION_SMS_CSKH_REMINDER_INSURANCE_TNDS: "Mẫu nhắc gia hạn bảo hiểm TNDS",
  STATION_SMS_CSKH_REMINDER_INSURANCE_BHTV:
    "Mẫu nhắc gia hạn bảo hiểm thân vỏ xe",
  STATION_SMS_CSKH_REMINDER_SERVICE_GPS: "Mẫu nhắc gia hạn dịch vụ GPS",
};
